import { Component, OnInit } from '@angular/core';
import { SystemConfig } from '../services/system-config.services';
import { AppConfiguration } from '../models/app-configuration.model';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-app-config',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './app-config.component.html',
  styleUrl: './app-config.component.scss',
})
export class AppConfigComponent implements OnInit {
  configForm!: FormGroup;
  configs: AppConfiguration[] = [];
  editMode = false;
  constructor(private fb: FormBuilder, private configService: SystemConfig) {}
  ngOnInit(): void {
    this.loadConfigs();
    this.configForm = this.fb.group({
      id: [null],
      configKey: ['', Validators.required],
      configValue: ['', Validators.required],
      description: [''],
    });
  }

  loadConfigs() {
    this.configService.getAllConfigurations().subscribe((data) => {
      this.configs = data;
    });
  }

  onSubmit() {
    if (this.configForm.invalid) return;

    const formValue: AppConfiguration = this.configForm.value;

    if (formValue.id) {
      this.configService.saveConfigurations(formValue).subscribe(() => {
        this.loadConfigs();
        this.resetForm();
      });
    } else {
      this.configService.saveConfigurations(formValue).subscribe(() => {
        this.loadConfigs();
        this.resetForm();
      });
    }
  }

  editConfig(config: AppConfiguration) {
    this.editMode = true;
    this.formVisible = true;
    this.configForm.patchValue(config);
  }

  resetForm() {
    this.editMode = false;
    this.formVisible = false;
    this.configForm.reset();
  }
  showFormForNew() {
    this.editMode = false;
    this.formVisible = true;
    this.configForm.reset(); // reset form for new entry
  }
  formVisible = false;
}
